import months from "./month.js";

export const parseDateInDD_MM_YYYY = (dateString) => {
    const {day, month, year} = getDayMonthYear(dateString);
    return  day +  '/' + month + '/' + year;
}

export const parseDateInYYY_MM_DD = (dateString) => {
    const {day, month, year} = getDayMonthYear(dateString);
    return year + '-' + month + '-' + day;
}

export const parseDateInDD__MM = (dateString) => {
    const {day, month} = getDateMonth(dateString);
    return day + '/' + month;
}

const getDayMonthYear = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = date.getMonth() + 1;
    const monthString = month <= 9 ? '0' + month : month;
    const year = date.getFullYear();

    return {
        day,
        monthNumber: month,
        month : monthString,
        year
    }
}

const getDateMonth = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = date.getMonth() + 1;
    const monthString = month <= 9 ? '0' + month : month;

    return {
        day,
        month : monthString,
    }
}

export const parseDateInMonthDateYear = (date) => {
    const {day,monthNumber,year} = getDayMonthYear(date)
    const monthData = months.find(month => month.monthIndex === (monthNumber-1))
    const monthInString =  monthData.name
    return monthInString + ' '+ day + ', ' + year
}

export const DATE_FORMATES = {
    parseDateInYYY_MM_DD : "parseDateInYYY_MM_DD",
    parseDateInMonthDateYear: 'parseDateInMonthDateYear'
}

export const convertDate = (dateString, format) => {
    switch(format) {
        case DATE_FORMATES.parseDateInYYY_MM_DD:
            return parseDateInYYY_MM_DD(dateString)
        case DATE_FORMATES.parseDateInMonthDateYear: 
            return parseDateInMonthDateYear(dateString)
        default :
            return ''
    }
}